<template>



      <v-card>



           <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>



        <v-card-title class="text-h5">
         
        </v-card-title>
        
<v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                

                <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <!-- <v-text-field
           v-model="user.name"
           label="Nombre"
           disabled
         ></v-text-field> -->

         


    <v-text-field
           v-model="email"
           label="Correo"
           disabled
         ></v-text-field>


                     <v-text-field
                      v-model="user.password"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="showPass ? 'text' : 'password'"
                      name="input-pass"
                      label="Contraseña Nueva"
                      hint="Minimo 5 caracteres"
                      counter
                      @click:append="showPass = !showPass"
                      data-cy="pass-input"
                    ></v-text-field>


                     <v-text-field
                      v-model="user.passwordConfirm"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min, matchPassword]"
                      :type="showPass ? 'text' : 'password'"
                      name="input-pass"
                      label="Repetir Contraseña"
                      hint="Minimo 5 caracteres"
                      counter
                      @click:append="showPass = !showPass"
                      data-cy="pass-input"
                    ></v-text-field>




    </v-form> 
            </v-card-text>
               


              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>


        - <v-card-actions>
           <v-spacer></v-spacer>
            <v-btn  outlined color="red darken-1"  text  
            @click="cancelar()"
            >
               <v-icon>
       mdi-cancel
      </v-icon> 
              Cancelar
            </v-btn>
            <v-btn outlined color="blue darken-4" 
            text @click="passChange()"
            data-cy="submit"
            >
            <v-icon>
       mdi-email-outline
      </v-icon> 
              Cambiar Seña
            </v-btn>
        </v-card-actions>  
      </v-card>


</template>




<script>

import loginService from "@/services/loginService.js";
//import  {storage} from "../../firebase"
//import  {uploadBytes} from "firebase/storage"
//import {ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
//import  CloudImage  from '../CloudImage.vue'

 
export default {

  
  data: vm => ({

      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 10000,
      },

  user:{
      password:''
  },
  signature:'',
  email:'',
  expires:'',
  urlPass:'',


  valid: false,
   
 showPass: false,
  
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                 
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
  }),
  components:{
     
  },
  mounted() {
   

   this.getQueryParams();

    this.constructUrl();
  },
  methods: {


getQueryParams() {
      let url = new URL(window.location.href);
      this.email = url.searchParams.get('email');
      this.signature = url.searchParams.get('signature');
      this.expires=url.searchParams.get('expires');

      console.log(this.email);
    },

    constructUrl() {
      let params = new URLSearchParams({
        email: this.email,
        signature: this.signature,
        expires: this.expires,
      });
      this.urlPass = `?${params.toString()}`;
    },


    matchPassword(value) {
      return value === this.user.password || 'Las contraseñas deben coincidir.';
    },
    cancelar(){


        this.user={};

    },
    passChange(){

           if (this.$refs.form.validate()) {

                console.log("Formulario Validado");

                

                loginService.passChange(this.urlPass,this.user).then(
        response =>{
       
            console.log('success');


             this.mensaje.text="Contraseña cambiada exitosamente, en breve se pasara a la pantalla de inicio de sesión";

             this.mensaje.color="primary";
      this.mensaje.colorBtn="blue";

      this.mensaje.snackbar="true";

      setTimeout(() => {
        this.$router.push('/login');
      }, 10000);


          
        }).catch((errors) =>{
//errors.message
          let mensajeError = '';

          mensajeError += "\n"+"Correo inexistente en la base de datos";

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
        
           console.log('error');
            console.log(errors);


           
        })

            }


      //console.log(user);
       //     this.$emit('userEdit',this.user);
       //     this.dialog=false;
        },
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.user={
				password:''
	}}
  


  
  
  },//fin methos

    watch: {
      date (val) {
        
			
		
       
      },
    },




}
    
  
</script>